import React, {Component} from 'react';
import axios from 'axios'
import ProcessButton from '../../../shared/process-button'

class Signup extends React.Component {
	constructor ( props ) {
		super();
		this.state = {
			formData: {
				email: '',
				name: '',
				password: '',
				mobile_number: ''
			},
			buttonActive: false,
			error: false,
			errorMsg: {},
			resetPassword: false,
			formSubmitted: false
		};
	}

	handleChange = (event) =>{

		const formData = this.state.formData;
		formData[event.target.name] = event.target.value;

		let active = false;
		if( this.state.formData.email.length > 0 && this.state.formData.name.length > 0 && this.state.formData.password.length > 0 ){
			active = true;
		}

		this.setState({ 'formData': formData, buttonActive: active } );
	}

	handleSubmit = (event) =>{

		event.preventDefault();

		this.setState({
			error: false,
			errorMsg: [],
			buttonActive: false,
			resetPassword: false,
			formSubmitted: true

		}, function() {

			const formData = {
				user: this.state.formData,
				authenticity_token: this.props.token,
				optout_marketing: this.props.optoutMarketing,
				short_name: 1
			};

			axios.post( '/signup.json', formData ).then(response => {
				this.props.handleAuthSuccess( response.data.user );
			}).catch(err => {

				let errors = {};

				if( err.response.status == 500 ) {
					errors.general = <ErrorMessage message={err.response.statusText} />
				} else {
					Object.keys(err.response.data.errors).map((key) => {
						errors[key] = <ErrorMessage message={err.response.data.errors[key]} />
					});
				}

				if( err.response.data.resetPassword ) {
					errors.email = <ResetMessage handleViewChange={this.props.handleViewChange} />
				}

				this.setState({
					buttonActive: true,
					formSubmitted: false,
					error: true,
					errorMsg: errors,
					resetPassword: err.response.data.resetPassword ? true : false,
				});

			});
		});
	}

	hasError = ( key, errorClass=false ) => {
		let messages = [];
		let errorClassList = [ errorClass ];

		if( this.state.errorMsg != undefined && this.state.errorMsg.hasOwnProperty( key ) ) {
			if( errorClass ) {
				errorClassList.push( 'animated shakeme input_error');
			} else {
				messages.push( this.state.errorMsg[key] );
			}
		} else {
			return errorClass ? errorClassList.join(' ') : null;
		}

		if( errorClass ) {
			return errorClassList.join(' ');
		} else {
			return messages;
		}
	}


	render() {

		return (
			<form onSubmit={this.handleSubmit} action="/signup" className="signup-form" autoComplete="on" acceptCharset="UTF-8" method="post">
				<div className="backBtn"><span className="icon icon-left"></span><a onClick={this.props.handleViewChange.bind(null, 'message')}>Back</a></div>

				{this.state.error && !this.state.errorMsg != undefined && this.state.errorMsg.general != undefined
					? <div className="callout danger">
						{this.state.errorMsg.general}
					</div>
					: null
				}



				<h4>Your details:</h4>
				<input name="email" type="email" value={this.state.formData.email} onChange={this.handleChange} className={this.hasError('email', 'form-margin')} placeholder="Your email address" type="email" />
				{this.hasError('email')}
				<input name="password" type="password" value={this.state.formData.password} onChange={this.handleChange}  className={this.hasError('password', 'form-margin')} placeholder="Choose a password" />
				{this.hasError('password')}
				<input name="name" type="text" value={this.state.formData.name} onChange={this.handleChange} placeholder="Your full name" className={this.hasError('name', 'form-margin')} />
				{this.hasError('name')}
				<input name="mobile_number" type="number" value={this.state.formData.mobile_number} onChange={this.handleChange} className={this.hasError('mobile_number', 'form-margin')} placeholder="Mobile number (optional)" />
				{this.hasError('mobile_number')}

				<label htmlFor="optout_marketing" className="checkbox inline tickbox-label-content">
					<input type="checkbox" id="optout_marketing" checked={this.props.optoutMarketing} name="optout_marketing" value="1" onChange={this.props.handleMarketingOptout} />
					<span>Tick this box if you would not like to receive Book a Party marketing offers and promotions via email.</span>
				</label>

				<ProcessButton
					buttonType="submit"
					buttonClass="button primary expanded"
					disabled={!this.state.buttonActive}
					process={this.state.formSubmitted}
				>
					Continue with email
				</ProcessButton>


				<div className="text-center">Have an account? <a onClick={(event) => this.props.handleViewChange('login', event)}>Login</a></div>

			</form>

		)
	}
}

const ResetMessage = props => (
	<div className="signup-invalid-message">Sorry the email you entered is already taken, if it's yours {<a onClick={(event) => props.handleViewChange('reset', event)}>reset your password</a>}</div>
);

const ErrorMessage = props => (
	<div className="signup-invalid-message">{props.message}</div>
);

export default Signup
